export default "__VITE_ASSET__08a21dcd__"